import React from "react";
import FileManagementComponent from "./FileManager.component";

function FileManagercontainer() {
  return (
    <div>
      <FileManagementComponent />
    </div>
  );
}

export default FileManagercontainer;
